/* eslint-disable react-native/no-inline-styles */
import React from "react";
import {
  Image,
  Platform,
  ScrollView,
  StatusBar,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Spacer from "./Spacer";
import { SafeAreaView } from "react-native-safe-area-context";
import { AppTheme } from "../../utils/theme";
import { AppIcons } from "../../assets/images";
import LinearGradient from "react-native-linear-gradient";

export type Props = { error: Error; resetError: () => void };

const FallbackComponent = (props: Props) => (
  <SafeAreaView
    style={styles.container}
    edges={{
      bottom: Platform.OS == "android" ? "additive" : "off",
      top: Platform.OS == "android" ? "additive" : "off",
    }}
  >
    <StatusBar backgroundColor={AppTheme.colors.linearGradient_3} />
    <View style={styles.content}>
      <Image source={AppIcons.Logo} style={styles.img} />
      <Text style={styles.title}>{"Oops!"}</Text>
      <Text style={styles.subtitle}>{"There's an error"}</Text>
      <ScrollView style={{ flex: 1 }}>
        <Text style={styles.error}>{props?.error?.toString()}</Text>
      </ScrollView>
    </View>
    <View style={{ width: "90%", alignSelf: "center" }}>
      {/* <C title="Try again" onPress={props?.resetError} /> */}
      <TouchableOpacity
        activeOpacity={1}
        style={{ alignSelf: "center", marginTop: 20 }}
        onPress={props?.resetError} // Updated to use helper
      >
        <LinearGradient
          colors={[
            AppTheme.colors.linearGradient_5,
            AppTheme.colors.linearGradient_6,
          ]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={styles.googleBtn1}
        >
          <LinearGradient
            colors={[
              AppTheme.colors.linearGradient_1,
              AppTheme.colors.linearGradient_2,
            ]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={styles.googleBtn}
          >
            <Text style={styles.startText}>{"Try again"}</Text>
          </LinearGradient>
        </LinearGradient>
      </TouchableOpacity>
    </View>
    <Spacer size={30} />
  </SafeAreaView>
);

export default FallbackComponent;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AppTheme.colors.linearGradient_3,
  },
  content: {
    flex: 1,
    padding: 20,
    paddingTop: Platform.OS == "ios" ? "20%" : "0%",
  },
  img: {
    width: 120,
    height: 120,
    alignSelf: "center",
    resizeMode: "contain",
  },
  title: {
    fontSize: 32,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 5,
    textAlign: "center",
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
    marginVertical: 14,
    color: AppTheme.colors.white,
  },
  subtitle: {
    fontSize: 20,
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
    alignSelf: "center",
  },
  error: {
    width: "100%",
    fontSize: 14,
    color: AppTheme.colors.red,
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
    marginTop: 20,
    textAlign: "justify",
  },
  googleBtn: {
    width: 250,
    height: 58,
    borderRadius: 30,
    justifyContent: "center",
  },

  googleBtn1: {
    width: 250,
    height: 65,
    borderRadius: 35,
  },
  startText: {
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 35,
    color: AppTheme.colors.white,
    textAlign: "center",
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
});
